import { Surfaces } from "@netlify/sdk--ui-core";
import React, { useContext } from "react";

export type SurfaceRouterContextState = {
  currentSurface: Surfaces | null;
};

export const SurfaceRouterContext =
  React.createContext<SurfaceRouterContextState>({
    currentSurface: null,
  });

export const SurfaceRouterContextProvider = SurfaceRouterContext.Provider;

export const useCurrentSurface = () => {
  return useContext(SurfaceRouterContext).currentSurface;
};
